<template>
  <section class="home">
    
    <home-svg></home-svg>
    <div class="tooltip"><div class="tooltip-content">λεκάνη</div></div>
  </section>
</template>

<script>

import HomeSvg from './HomeSvg'

export default {
  name: 'home',
  created: function() {
      window.document.title = "ΧΑΡΑΚΤΙΚΗ - ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ";
  },
  components: {
    HomeSvg
  },
  data () {
    return {
      msg: ''
    }
  },
  mounted: function() {
      this.$emit('hideLoader')
  },
}
</script>



// WEBPACK FOOTER //
// Home.vue?43ec6afc